// Helper function to calculate candle timestamp based on timeframe.
//
// Server bar times are UTC (ViiSyncConverters.ParseDateTime uses
// AssumeUniversal | AdjustToUniversal), so bucketing must use UTC boundaries.
// Intraday buckets (<= 12h) use plain epoch arithmetic (TZ-agnostic, since the
// Unix epoch is aligned to UTC midnight); 1d/1w/1mn use UTC calendar accessors
// so daily/weekly/monthly boundaries match the server bars regardless of the
// browser's local timezone.

const MINUTE_MS = 60_000;
const HOUR_MS = 3_600_000;
const DAY_MS = 86_400_000;

export const getCandleTimestamp = (time: string, timeframe: string): number => {
  const ts = new Date(time).getTime();

  switch (timeframe) {
    case "1m":
      return Math.floor(ts / MINUTE_MS) * MINUTE_MS;
    case "5m":
      return Math.floor(ts / (5 * MINUTE_MS)) * (5 * MINUTE_MS);
    case "15m":
      return Math.floor(ts / (15 * MINUTE_MS)) * (15 * MINUTE_MS);
    case "30m":
      return Math.floor(ts / (30 * MINUTE_MS)) * (30 * MINUTE_MS);
    case "1h":
      return Math.floor(ts / HOUR_MS) * HOUR_MS;
    case "2h":
      return Math.floor(ts / (2 * HOUR_MS)) * (2 * HOUR_MS);
    case "4h":
      return Math.floor(ts / (4 * HOUR_MS)) * (4 * HOUR_MS);
    case "12h":
      return Math.floor(ts / (12 * HOUR_MS)) * (12 * HOUR_MS);

    case "1d":
      // UTC midnight
      return Math.floor(ts / DAY_MS) * DAY_MS;

    case "1w": {
      // Align to Monday 00:00 UTC
      const date = new Date(ts);
      const d = date.getUTCDay(); // 0 Sun .. 6 Sat
      const daysFromMonday = d === 0 ? 6 : d - 1;
      return (
        Date.UTC(
          date.getUTCFullYear(),
          date.getUTCMonth(),
          date.getUTCDate() - daysFromMonday,
        )
      );
    }

    case "1mn": {
      // First of month, 00:00 UTC
      const date = new Date(ts);
      return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1);
    }

    default:
      return ts;
  }
};
